import { Injectable, inject } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { MarginCalculationsStore } from './margin-calculations.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';

@Injectable({ providedIn: 'root' })
export class MarginCalculationsReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginCalculationsStore = inject(MarginCalculationsStore);

    constructor() {
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(takeUntilDestroyed())
            .subscribe((event: EventPayload) => {
                this.marginCalculationsStore.updateMarginCalculationsFromData(
                    event.payload.marginDetails.marginCalculations
                );
            });
    }
}
